import React, {useEffect, useContext, useRef, useState, useMemo} from 'react';
import styles from './menu.module.css';
import useKeyPress from '../../hooks/useKeyPress';
import classNames from 'classnames';
import {findParent, useMenu} from '../../hooks/useMenu';
import MenuContext from '../../context/menuContext';
import useInitialfocus from './focus';
import ArrowRight from '../../assets/images/arrow_right_active.PNG';
import {findList, useCommonMenu} from '../../hooks/useCommonMenu';
import CheckActiveImg from '../../assets/images/checkmark_active.PNG';
import CheckImg from '../../assets/images/checkmark.PNG';
import CommandsContext from '../../context/commandsContext';
import ValuesContext from '../../context/valuesContext';

const ListItem = ({item, active, tapCount, initialSelected, selected}) => {
  const {values} = useContext(ValuesContext);

  return (
    <div id={`item-${item.id}`} className={styles.items}>
      <div>
        {item.requireDoubleRight && active && (tapCount === 1 || initialSelected) && (
          <img className={styles.checkActive} src={CheckActiveImg} />
        )}
        {item.requireDoubleRight && !active && initialSelected && (
          <img className={styles.checkActive} src={CheckImg} />
        )}
      </div>
      <div className={classNames('item', styles.item, {active})}>
        <span className={classNames('', item.requireDoubleRight && styles.check)}>{item.name}</span>
        {item.requireDoubleRight && active && (
          <div
            className={classNames(styles.valueColumnDiv, {active})}
            style={{background: !active && 'rgb(189, 197, 210)', width: active ? '34%' : '37%'}}>
            <span
              className={classNames(styles.valueColumn, active && tapCount === 1 && styles.blink)}>
              {tapCount === 1 ? 'Save?' : tapCount === 0 && !initialSelected ? 'Select' : ''}
            </span>
          </div>
        )}
      </div>
      {active && <img className={styles.arrowRight} src={ArrowRight} alt="Right" />}
    </div>
  );
};

const CommonMenu = ({menuItems, onPrevious, isMenuDisabled, initialValue, ...callbacks}) => {
  const [disabledMenu, setDisabledMenu] = useState(!!isMenuDisabled);
  const [items, setItems] = useState(menuItems);
  const [list, setList] = useState(menuItems);
  const [selected, setSelected] = useState(menuItems[0]);
  const {onComponent} = useMenu();

  const handleOnComponent = component => {
    onComponent(
      React.cloneElement(component, {
        ...component.props,
        onExit: onPrevious,
      }),
    );
  };

  const {onUp, onDown, onLeft, onRight, tapCount} = useCommonMenu({
    selected,
    setSelected,
    items,
    list,
    setItems,
    setList,
    onComponent: handleOnComponent,
    onPrevious,
    ...callbacks,
  });
  const downPress = useKeyPress('ArrowDown');
  const upPress = useKeyPress('ArrowUp');
  const rightPress = useKeyPress('ArrowRight');
  const leftPress = useKeyPress('ArrowLeft');
  const [initialSelected, setInitialSelected] = useState('');

  useEffect(() => {
    setInitialSelected(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (!initialSelected) return;

    const initial = menuItems.findIndex(item => item.name === initialSelected);

    if (initial === -1) return;

    setSelected(menuItems[initial]);
  }, [initialSelected]);

  useEffect(() => {
    if (!downPress || disabledMenu) {
      return;
    }
    onDown();
  }, [downPress]);

  useEffect(() => {
    if (!upPress || disabledMenu) {
      return;
    }
    onUp();
  }, [upPress]);

  useEffect(() => {
    if (!rightPress || disabledMenu) {
      return;
    }
    onRight();
    // onRightCallback?.(selected);
  }, [rightPress]);
  // }, [rightPress, onRight]);

  useEffect(() => {
    if (!leftPress || disabledMenu) {
      return;
    }

    onLeft();
  }, [leftPress, onLeft]);

  useEffect(() => {
    setTimeout(() => {
      setDisabledMenu(false);
    }, 500);
  }, []);

  useEffect(() => {
    if (!selected) {
      return;
    }

    const newList = findList(items, selected);

    if (list === newList) {
      return;
    }

    setList(newList);
  }, [selected]);

  const mainRef = useRef(null);
  useInitialfocus(mainRef);

  useEffect(() => {
    if (!mainRef.current) return;

    const handler = e => {
      if (['Space', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.code) > -1) {
        e.preventDefault();
      }
    };

    mainRef.current.addEventListener('keydown', handler, false);

    return () => {
      if (!mainRef.current) return;
      mainRef.current.removeEventListener('keydown', handler, false);
    };
  }, [mainRef]);

  useEffect(() => {
    if (!selected) {
      return;
    }

    setTimeout(() => {
      const element = document.getElementById(`item-${selected.id}`);
      if (!element) return;
      mainRef.current.scrollTo(0, element.offsetTop - 83);
    });
  }, [selected]);

  return (
    <>
      {/* <div className={showInfo || component ? styles.topHide : styles.top}>
        <span className={styles.topText}> {parent?.name ?? 'Main Menu'}</span>
      </div> */}
      <div ref={mainRef} tabIndex="-1" className={styles.menuList}>
        {list.map((item, i) => (
          <ListItem
            key={item.id}
            active={item.id === selected?.id}
            item={item}
            setSelected={setSelected}
            selected={selected}
            tapCount={tapCount}
            initialSelected={initialSelected === item.name}
          />
        ))}
      </div>
    </>
  );
};

export default CommonMenu;
